import { deepFreeze, } from '@tymia/shared';
import { memoize, } from 'micro-memoize';
import { guessLocale, } from './translation/translation.js';
const languages = Object.freeze([
    'aa',
    'ab',
    'ae',
    'af',
    'ak',
    'am',
    'an',
    'ar',
    'as',
    'av',
    'ay',
    'az',
    'ba',
    'be',
    'bg',
    'bi',
    'bm',
    'bn',
    'bo',
    'br',
    'bs',
    'ca',
    'ce',
    'ch',
    'co',
    'cr',
    'cs',
    'cu',
    'cv',
    'cy',
    'da',
    'de',
    'dv',
    'dz',
    'ee',
    'el',
    'en',
    'eo',
    'es',
    'et',
    'eu',
    'fa',
    'ff',
    'fi',
    'fj',
    'fo',
    'fr',
    'fy',
    'ga',
    'gd',
    'gl',
    'gn',
    'gu',
    'gv',
    'ha',
    'he',
    'hi',
    'ho',
    'hr',
    'ht',
    'hu',
    'hy',
    'hz',
    'ia',
    'id',
    'ie',
    'ig',
    'ii',
    'ik',
    'io',
    'is',
    'it',
    'iu',
    'ja',
    'jv',
    'ka',
    'kg',
    'ki',
    'kj',
    'kk',
    'kl',
    'km',
    'kn',
    'ko',
    'kr',
    'ks',
    'ku',
    'kv',
    'kw',
    'ky',
    'la',
    'lb',
    'lg',
    'li',
    'ln',
    'lo',
    'lt',
    'lu',
    'lv',
    'mg',
    'mh',
    'mi',
    'mk',
    'ml',
    'mn',
    'mr',
    'ms',
    'mt',
    'my',
    'na',
    'nb',
    'nd',
    'ne',
    'ng',
    'nl',
    'nn',
    'no',
    'nr',
    'nv',
    'ny',
    'oc',
    'oj',
    'om',
    'or',
    'os',
    'pa',
    'pi',
    'pl',
    'ps',
    'pt',
    'qu',
    'rm',
    'rn',
    'ro',
    'ru',
    'rw',
    'sa',
    'sc',
    'sd',
    'se',
    'sg',
    'sh',
    'si',
    'sk',
    'sl',
    'sm',
    'sn',
    'so',
    'sq',
    'sr',
    'ss',
    'st',
    'su',
    'sv',
    'sw',
    'ta',
    'te',
    'tg',
    'th',
    'ti',
    'tk',
    'tl',
    'tn',
    'to',
    'tr',
    'ts',
    'tt',
    'tw',
    'ty',
    'ug',
    'uk',
    'ur',
    'uz',
    've',
    'vi',
    'vo',
    'wa',
    'wo',
    'xh',
    'yi',
    'yo',
    'za',
    'zh',
    'zu',
]);
const fallback = deepFreeze({
    aa: {
        'de-DE': 'Afar',
        'en-US': 'Afar',
    },
    ab: {
        'de-DE': 'Abchasisch',
        'en-US': 'Abkhazian',
    },
    ae: {
        'de-DE': 'Avestisch',
        'en-US': 'Avestan',
    },
    av: {
        'de-DE': 'Awarisch',
        'en-US': 'Avaric',
    },
    ba: {
        'de-DE': 'Baschkirisch',
        'en-US': 'Bashkir',
    },
    bi: {
        'de-DE': 'Bislama',
        'en-US': 'Bislama',
    },
    bo: {
        'de-DE': 'Tibetisch',
        'en-US': 'Tibetan',
    },
    ce: {
        'de-DE': 'Tschetschenisch',
        'en-US': 'Chechen',
    },
    ch: {
        'de-DE': 'Chamorro',
        'en-US': 'Chamorro',
    },
    cr: {
        'de-DE': 'Cree',
        'en-US': 'Cree',
    },
    cu: {
        'de-DE': 'Kirchenslawisch',
        'en-US': 'Church Slavic',
    },
    cv: {
        'de-DE': 'Tschuwaschisch',
        'en-US': 'Chuvash',
    },
    dz: {
        'de-DE': 'Dzongkha',
        'en-US': 'Dzongkha',
    },
    ff: {
        'de-DE': 'Ful',
        'en-US': 'Fulah',
    },
    fj: {
        'de-DE': 'Fidschi',
        'en-US': 'Fijian',
    },
    gv: {
        'de-DE': 'Manx',
        'en-US': 'Manx',
    },
    ho: {
        'de-DE': 'Hiri-Motu',
        'en-US': 'Hiri Motu',
    },
    hz: {
        'de-DE': 'Herero',
        'en-US': 'Herero',
    },
    ie: {
        'de-DE': 'Interlingue',
        'en-US': 'Interlingue',
    },
    ii: {
        'de-DE': 'Yi',
        'en-US': 'Sichuan Yi',
    },
    ik: {
        'de-DE': 'Inupiak',
        'en-US': 'Inupiaq',
    },
    io: {
        'de-DE': 'Ido',
        'en-US': 'Ido',
    },
    iu: {
        'de-DE': 'Inuktitut',
        'en-US': 'Inuktitut',
    },
    kg: {
        'de-DE': 'Kongolesisch',
        'en-US': 'Kongo',
    },
    ki: {
        'de-DE': 'Kikuyu',
        'en-US': 'Kikuyu',
    },
    kj: {
        'de-DE': 'Kwanyama',
        'en-US': 'Kuanyama',
    },
    kl: {
        'de-DE': 'Grönländisch',
        'en-US': 'Kalaallisut',
    },
    kr: {
        'de-DE': 'Kanuri',
        'en-US': 'Kanuri',
    },
    ks: {
        'de-DE': 'Kaschmiri',
        'en-US': 'Kashmiri',
    },
    kv: {
        'de-DE': 'Komi',
        'en-US': 'Komi',
    },
    kw: {
        'de-DE': 'Kornisch',
        'en-US': 'Cornish',
    },
    li: {
        'de-DE': 'Limburgisch',
        'en-US': 'Limburgish',
    },
    lu: {
        'de-DE': 'Luba-Katanga',
        'en-US': 'Luba-Katanga',
    },
    mh: {
        'de-DE': 'Marschallesisch',
        'en-US': 'Marshallese',
    },
    na: {
        'de-DE': 'Nauruisch',
        'en-US': 'Nauru',
    },
    nd: {
        'de-DE': 'Nord-Ndebele',
        'en-US': 'North Ndebele',
    },
    ng: {
        'de-DE': 'Ndonga',
        'en-US': 'Ndonga',
    },
    nr: {
        'de-DE': 'Süd-Ndebele',
        'en-US': 'South Ndebele',
    },
    nv: {
        'de-DE': 'Navajo',
        'en-US': 'Navajo',
    },
    oj: {
        'de-DE': 'Ojibwa',
        'en-US': 'Ojibwa',
    },
    os: {
        'de-DE': 'Ossetisch',
        'en-US': 'Ossetic',
    },
    pi: {
        'de-DE': 'Pali',
        'en-US': 'Pali',
    },
    rn: {
        'de-DE': 'Rundi',
        'en-US': 'Rundi',
    },
    sc: {
        'de-DE': 'Sardisch',
        'en-US': 'Sardinian',
    },
    se: {
        'de-DE': 'Nordsamisch',
        'en-US': 'Northern Sami',
    },
    sg: {
        'de-DE': 'Sango',
        'en-US': 'Sango',
    },
    ss: {
        'de-DE': 'Swazi',
        'en-US': 'Swati',
    },
    ty: {
        'de-DE': 'Tahitisch',
        'en-US': 'Tahitian',
    },
    ve: {
        'de-DE': 'Venda',
        'en-US': 'Venda',
    },
    vo: {
        'de-DE': 'Volapük',
        'en-US': 'Volapük',
    },
    za: {
        'de-DE': 'Zhuang',
        'en-US': 'Zhuang',
    },
});
export const getLanguages = memoize(function getLanguageNames(locale) {
    const supportedLocale = guessLocale(locale);
    const collator = new Intl.Collator(supportedLocale);
    const displayNames = new Intl.DisplayNames([supportedLocale], {
        type: 'language',
        languageDisplay: 'standard',
        fallback: 'none',
    });
    const result = languages.map(iso => ({
        iso,
        display: displayNames.of(iso) ?? fallback[iso]?.[supportedLocale] ?? iso,
    }));
    return result.sort((a, b) => collator.compare(a.display, b.display));
}, {
    maxSize: 10,
});
//# sourceMappingURL=languages.js.map